function ExtrapolateTop(string){
    let firstPart = (string).toString().split("translate3d(0px,").pop();
    let secondPart = firstPart.split(",")
    return secondPart[0].split("-").pop();
}
export default ExtrapolateTop
